// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useSnackbar } from 'notistack';

export const useCopyToClipboard = () => {
  const { enqueueSnackbar } = useSnackbar();

  const copyToClipboard = (value: string) => {
    navigator.clipboard
      .writeText(value)
      .then(() => enqueueSnackbar('Successfully copied to clipboard', { variant: 'success' }))
      .catch(() => enqueueSnackbar('Failed to copy to clipboard', { variant: 'error' }));
  };
  return copyToClipboard;
};
